module.exports = __webpack_public_path__ + "img/selected6-min.3b6bc881.png";